export default "__VITE_ASSET__1db95019__"